import { EMPTY_CELL } from '@/utils/collectionUtils';

export const yesNoCell = <T>(key: keyof T) => {
  return (item: T) => {
    // Nullish, not just null: an undefined field would otherwise fall through
    // the ternary below and render as "No".
    if (item[key] === null || item[key] === undefined) {
      return EMPTY_CELL;
    }

    // TODO: translations
    return item[key] ? 'Yes' : 'No';
  };
};
